module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/cw_my_apps_getting_started-850a51645a7de9439708004319e4f269.svg";